import React from 'react';
import { TermsCheckbox } from './TermsCheckbox';

type SignupStepFooterProps = {
  onSwitchToLogin?: () => void;
  showTermsAndConditions?: boolean;
  termsChecked?: boolean;
  onTermsChange?: (checked: boolean) => void;
};

export const SignupStepFooter: React.FC<SignupStepFooterProps> = ({
  onSwitchToLogin,
  showTermsAndConditions = true,
  termsChecked = false,
  onTermsChange,
}) => {
  return (
    <div className="self-stretch text-center mt-1">
      {/* Terms checkbox - centered */}
      {showTermsAndConditions && (
        <div className="flex justify-center">
          <div className="w-full max-w-[600px]">
            <TermsCheckbox checked={termsChecked} onChange={onTermsChange || (() => {})} />
          </div>
        </div>
      )}

      {/* Already have an account - 4px below terms text */}
      {onSwitchToLogin && (
        <div className="mt-1">
          <span className="text-black text-xs font-normal leading-5">Already have an account? </span>
          <button
            onClick={onSwitchToLogin}
            className="bg-transparent border-0 p-0 text-black text-xs font-extrabold underline leading-5 cursor-pointer"
          >
            Log In
          </button>
        </div>
      )}
    </div>
  );
};
